import { render, staticRenderFns } from "./registration-details.vue?vue&type=template&id=7ab26d8a&scoped=true&"
import script from "./registration-details.vue?vue&type=script&lang=js&"
export * from "./registration-details.vue?vue&type=script&lang=js&"
import style0 from "./registration-details.vue?vue&type=style&index=0&id=7ab26d8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab26d8a",
  null
  
)

component.options.__file = "registration-details.vue"
export default component.exports